export function* asyncGenerator(count: number) {
  let i = 0;
  while (i < count) {
    // eslint-disable-next-line no-plusplus
    yield i++;
  }
}
